import { z } from "zod";
import { ExtendedScheduleReasonSchema } from "@remi/enums/extended-schedule-reason";
import { RescheduleReasonSchema } from "@remi/enums/reschedule-reason";
import { TaskType } from "@remi/enums/task-type";

export const InstallScheduledTaskAttemptSchema = z.object({
  type: z.literal(TaskType.INSTALL_SCHEDULED),
  reason: RescheduleReasonSchema,
  installScheduledAt: z.coerce.date().nullable(),
  estimatedProductionDays: z.number().nullable(),
  extendedScheduleReason: ExtendedScheduleReasonSchema.optional(),
  extendedScheduleOtherDetails: z.string().nullish(),
  scheduledTimeSlot: z.string().nullish(),
  // Only read on an unschedule (installScheduledAt null): when Schedule work comes back to the contractor.
  followUpDate: z.coerce.date().nullish(),
  // Stamped by the handler from the agent-action execution, never taken from a client, so scorecards can tell a
  // backdated agent catch-up from a person's own late entry.
  agentActionId: z.string().optional(),
});

export type InstallScheduledTaskAttempt = z.infer<typeof InstallScheduledTaskAttemptSchema>;
